import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import login1 from '../assets/Images/login.jpg';
import sponsor1 from '../assets/Images/images.jpg';
import Cewas from '../assets/Images/Cewas.png';
import WFP from '../assets/Images/WFP.jpg';
import logo from '../assets/Images/logo.png';
import eyeIcon from '../assets/Images/view.png'; 
import eyeOffIcon from '../assets/Images/hide.png';
import api from '../Components/BaseURL/BaseURL';
import { useAuth } from '../Components/Contexts/AuthContext';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const { login  } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    try {
      // First try institution login
      const institutionResponse = await api.post('/institution/login', { email, password });

      if (institutionResponse.status === 200 && institutionResponse.data.status) {
        const { token, institution } = institutionResponse.data.data;

        login(token); // ✅ Save token using AuthContext
        localStorage.setItem('institutionDetails', JSON.stringify(institution));

        navigate('/supervisor'); // ✅ Navigate to dashboard
        return;
      }
    } catch {
      try {
        // If institution login fails, try employee login
        const employeeResponse = await api.post('/employee/login', { email, password });

        if (employeeResponse.status === 200 && employeeResponse.data.status) {
          const { token, employee } = employeeResponse.data.data;

          login(token); // ✅ Save token using AuthContext
          localStorage.setItem('employeeDetails', JSON.stringify(employee));

          navigate('/employee'); // ✅ Navigate to dashboard
        }
      } catch (error) {
        setErrorMessage(error.response?.data?.message || 'حدث خطأ أثناء تسجيل الدخول');
      }
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      navigate('/supervisor'); // ✅ Ensure logged-in users are redirected
    }
  }, [navigate]);
  return (
    <div className="relative w-full min-h-screen flex bg-white">
      {/* Left Image Section */}
      <div className="hidden lg:flex w-[50%] min-h-screen items-center justify-center relative">
  {/* Image */}
  <img
    src={login1}
    alt="Login Background"
    className="w-full h-full object-cover"
  />
    <div className="absolute inset-0 bg-black/40"></div>

 <div className="absolute bottom-0 left-4">
    <img
      src={logo}
      alt="Logo"
      className="w-44 h-auto object-contain"
    />
  </div>
  {/* Black Gradient Overlay */}
  {/* <div
    className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent"
  ></div> */}
</div>

<div className="block absolute top-8 left-[3%] md:left-[8%] lg:left-[48%]">
    <img
      src={logo}
      alt="Logo"
      className="w-40 h-auto object-contain"
    />
  </div>
      {/* Form Container */}
      <div className="w-full lg:w-[60%] flex flex-col items-center mx-10 lg:mx-0 mt-40 lg:mt-40 xl:mt-40 relative">
        

  
        <h1 className="text-2xl text-center font-bold text-[#DD5B35] mb-6">
          تسجيل الدخول
        </h1>
        <form
          onSubmit={handleSubmit}
          className="text-right w-full md:w-[80%] xl:w-[60%]"
        >
          <div className="mb-6">
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              <span className="text-red-500"> *</span>
              اسم المستخدم
            </label>
            <input
              type="email"
              id="email"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none  border-[#DD5B35] text-right"
              placeholder="أدخل اسم المستخدم"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-6">
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              <span className="text-red-500"> *</span>
              كلمة المرور
            </label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'} // 👁 Toggle between "text" and "password"
                id="password"
                className="w-full px-4 py-2 border rounded-lg focus:outline-none border-[#DD5B35] text-right "
                placeholder="أدخل كلمة المرور"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              {/* Toggle Button (Eye Icon) */}
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)} // Toggle showPassword state
                className="absolute inset-y-0 left-3 flex items-center"
              >
                <img src={showPassword ? eyeIcon : eyeOffIcon} alt="Toggle Password" className="w-6 h-6" />
              </button>
            </div>
          </div>
          {errorMessage && <p className="text-red-500 mt-4 text-center">{errorMessage}</p>}
          {/* <div className="mb-12">
            <label
              htmlFor="role"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              الدور
            </label>
            <select
              id="role"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-right"
              style={{ direction: 'rtl' }}
            >
              <option value="employee">موظف</option>
              <option value="supervisor">مشرف</option>
            </select>
          </div> */}

          <div className="flex justify-center mt-6">
            <button
              type="submit"
              className="w-1/2 lg:w-1/3 bg-[#DD5B35] text-white py-3 px-4 rounded-lg hover:bg-[#275f2f]"
            >
              تسجيل الدخول
            </button>
          </div>
          
        </form>
        <h1 className="mt-8 text-gray-600 text-center font-bold px-8 md:px-14">
        متعقب هدر الطعام   <br />  Food Waste Tracker
        </h1>
 <p className="mt-2 text-gray-600 text-center px-8 md:px-14">
 نظام إلكتروني مخصص لإدارة ومتابعة بيانات هدر الطعام في المنشآت الغذائية (مثل: المستشفيات والفنادق والمصانع)، بهدف تحقيق الاستدامة وتقليل هدر الطعام.
        </p>
        {/* Sponsors Section */}
        <div className="w-full mt-4 text-end relative">
          <h2 className="text-2xl text-end font-semibold text-gray-700 mb-2 mr-0 md:mr-5">
            :بدعم من
          </h2>
          <div className="flex justify-center gap-8">
            <img
              src={Cewas}
              alt="Sponsor 2"
              className="w-28 h-auto object-contain"
            />
            <img
              src={sponsor1}
              alt="Sponsor 1"
              className="w-28 h-auto object-contain"
            />
            <img
              src={WFP}
              alt="Sponsor 3"
              className="w-24 h-auto object-contain"
            />
          </div>

          {/* Arrow pointing to sponsors */}
          {/* <div className="absolute right-[-280px] bottom-[-380px] transform rotate-360">
  <div
    className="w-[489px] h-[489px] rounded-full"
    style={{
      background: 'rgba(0, 128, 255, 0.2)', // #0080FF with 20% opacity
      filter: 'blur(40px)', // Adds a soft blur effect
    }}
  ></div>
</div> */}






        </div>
      
      </div>
    </div>
  );
}

export default Login;
